@keyframes platform-toast-countdown {
    from {
        transform: scaleX(1);
    }
    to {
        transform: scaleX(0);
    }
}

@keyframes platform-toast-spin {
    to {
        transform: rotate(360deg);
    }
}

.platform-toast__loading-icon {
    animation: platform-toast-spin 0.9s linear infinite;
}

/* In-app notifications enter and leave through their anchored right edge.
   The feedback lane retains Sonner's vertical bottom-right motion. */
.platform-toast-host--in-app [data-sonner-toast][data-front='true'] {
    --y: translateX(calc(100% + 1rem));
}

.platform-toast-host--in-app [data-sonner-toast][data-front='true'][data-mounted='true'] {
    --y: translateX(0);
}

.platform-toast-host--in-app [data-sonner-toast][data-removed='true'][data-front='true'][data-swipe-out='false'],
.platform-toast-host--in-app [data-sonner-toast][data-removed='true'][data-front='false'][data-swipe-out='false'] {
    --y: translateX(calc(100% + 1rem));
}

.platform-toast__collapsible {
    display: grid;
    grid-template-rows: 1fr;
    margin-block-end: 0;
    margin-inline: -0.75rem;
    opacity: 1;
    transition:
        grid-template-rows var(--platform-toast-motion-duration, 0.1s) var(--platform-toast-motion-easing, ease-in-out),
        margin-block-end var(--platform-toast-motion-duration, 0.1s) var(--platform-toast-motion-easing, ease-in-out),
        opacity var(--platform-toast-motion-duration, 0.1s) var(--platform-toast-motion-easing, ease-in-out),
        visibility 0s linear 0s;
    visibility: visible;
    width: calc(100% + 1.5rem);
}

.platform-toast__collapsible[data-has-expiry-footer='true'] {
    margin-block-end: -0.75rem;
}

.platform-toast__collapsible[data-collapsed='true'] {
    grid-template-rows: 0fr;
    margin-block-end: 0;
    opacity: 0;
    pointer-events: none;
    transition:
        grid-template-rows var(--platform-toast-motion-duration, 0.1s) var(--platform-toast-motion-easing, ease-in-out),
        margin-block-end var(--platform-toast-motion-duration, 0.1s) var(--platform-toast-motion-easing, ease-in-out),
        opacity var(--platform-toast-motion-duration, 0.1s) var(--platform-toast-motion-easing, ease-in-out),
        visibility 0s linear var(--platform-toast-motion-duration, 0.1s);
    visibility: hidden;
}

.platform-toast__collapsible-inner {
    min-height: 0;
    overflow: hidden;
}

.platform-toast__progress-track {
    bottom: 0;
    height: 0.125rem;
    left: 0;
    overflow: hidden;
    position: absolute;
    width: 100%;
}

.platform-toast__progress {
    animation: platform-toast-countdown var(--platform-toast-duration) linear forwards;
    display: block;
    height: 100%;
    transform-origin: left center;
    width: 100%;
}

[data-sonner-toast][data-expanded='true'] .platform-toast__progress {
    animation-play-state: paused;
}

@media (prefers-reduced-motion: reduce) {
    .platform-toast__collapsible,
    .platform-toast__actions {
        transition: none;
    }
}
